import { ValidationError } from '../utils/errors';
import ApiService from './ApiService';
export default class ChainsService {
    constructor() {
        this.chains = [];
        this.loadingPromise = this.loadAvailableChains();
    }
    async loadAvailableChains() {
        this.chains = await ApiService.getChains();
    }
    static getInstance() {
        if (!this.instance) {
            this.instance = new ChainsService();
        }
        return this.instance;
    }
    async getChainById(chainId) {
        if (this.loadingPromise) {
            await this.loadingPromise;
        }
        const chain = this.chains.find((chain) => chain.id === chainId);
        if (!chain) {
            throw new ValidationError(`Unknown chainId passed: ${chainId}.`);
        }
        return chain;
    }
    async getChains() {
        if (this.loadingPromise) {
            await this.loadingPromise;
        }
        return this.chains;
    }
}
